const collectionMap = new Map();
let shopifyQty1 = varintsShopifyStore;
shopifyQty1.split(",").map(res => {
	let sp = res.split("/");
	collectionMap.set(sp[0], sp[1]);
});
let countryCodeTemp = "";
if (typeof countryCode !== 'undefined') {
    countryCodeTemp = countryCode;
}
function webbeeGeolocation19(variantSku, domainName) {
	let encodedValues = encodeURIComponent(JSON.stringify({ "variantSKUList": variantSku, "domainName": domainName ,"countryCode": countryCodeTemp}));
	$.ajax({
		type: 'GET', url: 'https://hooks.webbeeglobal.com/ShopifyAmazonFBAConnecotr/shopify/location-qty', async: false,
		dataType: 'jsonp', jsonp: 'callback', jsonpCallback: 'callback', data: encodedValues,
		success: function(callback) {
			if (callback['status'] == 'success' && callback['data'].length > 0) {
				responseFromServer = callback['data'];
				for (let i = 0; i < responseFromServer.length; i++) {
					let object = responseFromServer[i];
					idquantity.set(object['variantSKU'], object['quantity']);
				}
				try{
				if(page==="listpage"){
					soldOutGeoLocation();
				}
				}catch(exception){
				}
					let qty = idquantity.get(webbeeSku);
					if(qty===0 || qty===null || qty===undefined){
						$(btn).attr("disabled",true);
						try{
						if(txt){
						$(btn).html(txt);
						}
						}catch(Exception){}
					}else{
						$(btn).attr("disabled", false);
					}
			}else if(callback['status'] == 'fail' && callback['geoLocationZeroInventory'] == 'Yes'){
				idquantity.set('zero inventory', true); 
			}else{
					let qty = idquantity.get(webbeeSku);
					if(qty===0 || qty===null || qty===undefined){
						$(btn).attr("disabled",true);
						try{
						if(txt){
						$(btn).html(txt);
						}
						}catch(Exception){}
					}else{
						$(btn).attr("disabled", false);
					}
                }
		},
		error: function(jqXHR, textStatus, errorThrown) {
			$(btn).attr("disabled", false);
		}
	});
}
document.addEventListener('DOMContentLoaded', function() {
	console.log("vavvvvvvvvvvvvvvv test ==================" + variantSku);
    webbeeGeolocation19(variantSku, domainName);
});

$(btn).on('click', function(evt) {
	let skus = $("#webbeesku").val();
	skus = webbeeSku;
	let qty = idquantity.get(skus);	
	let cartqty = collectionMap.get(skus);
	if (cartqty === undefined) {
		cartqty = 0;
	}
	if (Number(cartqty) + 1 > Number(qty)) {
		$(btn).attr("disabled", "true");
		evt.preventDefault();
		$("#msg").html("Available quantity " + Number(qty));
	} else {
		$("#msg").html("");
	}
	if (qty === undefined || qty === 0) {
		$(btn).attr("disabled", "true");
		$("#msg").html("Available quantity 0");
		evt.preventDefault();
	}
})